import React, { FC } from 'react';
import { Checkbox, IconButton, Stack, TableCell, TableRow } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import { AlertConditionType } from 'features/alerts/types';
import { cellStyle, selectedCellStyle, unselectedStyle } from './styles';
import { useTranslation } from 'react-i18next';
import { Station } from 'features/predictionMap/api/getStations';
import { sendAnalyticsEvent } from '../../../../utils/googleAnalytics';

type tableDataType = {
  idx: number;
  id: string;
  name: string;
  address: string;
  is_area: boolean;
  conditions: AlertConditionType[];
  station: Station | null;
};

type tableRowProps = {
  d: tableDataType;
  setSelectedRow: React.Dispatch<React.SetStateAction<number | null>>;
  isSelected: boolean;
  handleDeleteClick: (id: string) => () => Promise<void>;
  idx: number;
};

const NormalTableRow: FC<tableRowProps> = ({
  d,
  setSelectedRow,
  isSelected,
  handleDeleteClick,
  idx,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const toggleCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    // GA4: アラート一覧の行選択を計測
    sendAnalyticsEvent('alert_list', {
      action: e.target.checked ? 'select_row' : 'unselect_row',
      alert_type: d.station ? 'river_level' : d.is_area ? 'area' : 'point',
    });
    if (e.target.checked) {
      setSelectedRow(Math.round(idx));
    } else {
      setSelectedRow(null);
    }
  };

  return (
    <TableRow key={d.idx} style={isSelected ? selectedCellStyle : unselectedStyle}>
      <TableCell style={cellStyle}>
        <Checkbox checked={isSelected} onChange={toggleCheckbox} />
      </TableCell>
      <TableCell style={cellStyle}>{d.name}</TableCell>
      <TableCell style={cellStyle}>{d.station ? t('pages.alerts.waterLevel') : t('pages.alerts.floodDepth')}</TableCell>
      <TableCell style={cellStyle}>{d.address}</TableCell>
      <TableCell style={cellStyle}>
        {d.is_area ? t('pages.alerts.asArea') : t('pages.alerts.asPoint')}
      </TableCell>
      <TableCell style={cellStyle}>{d.conditions.length}</TableCell>
      <TableCell style={cellStyle}>
        <Stack direction="row">
          <IconButton
            aria-label="edit"
            onClick={() => {
              // GA4: アラート編集ボタンのクリックを計測
              sendAnalyticsEvent('alert_list', {
                action: 'click_edit',
                alert_type: d.station ? 'river_level' : d.is_area ? 'area' : 'point',
              });
              if (d.station) {
                navigate(`/prediction/edit_alert?id=${d.id}&is_area=${d.is_area}&is_river=true`);
              } else {
                navigate(`/prediction/edit_alert?id=${d.id}&is_area=${d.is_area}`);
              }
            }}
          >
            <EditIcon style={{ fontSize: '14pt' }} />
          </IconButton>
          <IconButton aria-label="edit" onClick={handleDeleteClick(String(d.id))}>
            <DeleteIcon style={{ fontSize: '14pt' }} />
          </IconButton>
        </Stack>
      </TableCell>
    </TableRow>
  );
};

export default NormalTableRow;
